
export const Bio = {
  name: "Debdipto Biswas",
  roles: [
    "Full Stack Developer",
    "Web Developer",
    "Programmer",
  ],
  description:
    "I'm an enthusiastic and adaptable person, constantly seeking new opportunities to excel. Driven by a deep love for learning, I am committed to producing top-notch outcomes. Fueled by optimism and a commitment to personal growth, I am prepared to make a significant impact and accomplish remarkable feats.",
  github: "https://github.com/DebdiptoBiswas",
  resume: "https://rxresu.me/devdiptobiswas722/resume1",
  linkedin: "https://www.linkedin.com/in/debdipto-biswas-186913247/",
};
export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },

    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Java",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original-wordmark.svg",
      },
      {
        name: "Python",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
      },
      {
        name: "C++",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
      },
      {
        name: "MySQL",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      },
      
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original-wordmark.svg",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://i.ibb.co/0jvsmhY/pngegg.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "DiscordJs",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/discordjs/discordjs-original.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/D5603AQHjyc5u3DYYyQ/profile-displayphoto-shrink_800_800/0/1687411000525?e=2147483647&v=beta&t=UKUeRr-IQgNSpXl632tn1YQ-Yyl1qTxSLz6uG71PhKI", //not
    school: "Vellore Instutute of Technology, Chennai",
    date: "July 2021 - Sept 2025",
    grade: "7.52 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Vellore Instutute of Technology, Chennai. I have completed 5 semesters and have a CGPA of 7.54. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, and Computer Networks, among others.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering with speacialisation in Cyber Physical Systems",
  },
  {
    id: 1,
    img: "https://i0.wp.com/dpsrkp.net/v1wp_oll/wp-content/uploads/2019/08/logo.png?ssl=1",//not working
    school: "Delhi Public School, Bokaro Steel City",
    date: "Apr 2020 - Mar 2021",
    grade: "94.6%",
    desc: "I completed my class 12 high school education at Delhi Public School, Bokaro Steel City, where I studied Science.",
    degree: "CBSE(XII), Science",
  },
  {
    id: 2,
    img: "https://i0.wp.com/dpsrkp.net/v1wp_oll/wp-content/uploads/2019/08/logo.png?ssl=1", //not working
    school: "Delhi Public School, Bokaro Steel City",
    date: "Apr 2018 - Mar 2019",
    grade: "96.4%",
    desc: "I completed my class 10 education at Delhi Public School, Bokaro Steel City.",
    degree: "CBSE(X)",
  },
];

export const projects = [
  {
    id: 9,
    title: "TinDog",
    date: "Mar 2023 - Jun 2023",
    description:
      "Inspired from Tinder website. A Tinder clone Made using HTML,CSS,Bootstrap",
    tags: ["Web cloning","HTML","CSS","Bootstrap","Web development",
    ],
    category: "Bootstrap",
    image:"https://i.ibb.co/s6z7KJH/Screenshot-2024-03-16-192751.png",
    github: "https://github.com/DebdiptoBiswas/TinDogProject",
    webapp :"https://debdiptobiswas.github.io/TinDogProject/",
  },
  {
    id: 0,
    title: "Drum Kit",
    date: "Jul 2023 - Oct 2023",
    description:
      "A click operated drumming website using js, css, html",
    
    tags: [
      "Website-Audio-Response", "HTML", "CSS", "Javascript",  ],
    category: "Javascript",
    image:"https://i.ibb.co/XYBpVgQ/Screenshot-2024-03-16-192630.png",
    github: "https://github.com/DebdiptoBiswas/DrumKit",
    webapp: "https://debdiptobiswas.github.io/DrumKit/",
  },
  {
    id: 1,
    title: "Dicee",
    date: "Oct 2023 - Nov 2023",
    description:
      "A dice roll website made using html, css, js for two players",
    
    tags: [
      "Javascript",
      "HTML",
      "CSS",
      "Gaming-website",
    ],
    image: "https://i.ibb.co/7bbvnBW/Screenshot-2024-03-16-192503.png",
    category: "Javascript",
    github: "https://github.com/DebdiptoBiswas/TheDiceeGame",
    webapp: " https://debdiptobiswas.github.io/TheDiceeGame/",
  },

  {
    id: 2,
    title: "Web-Design-Agency-Project",
    date: "Nov 2022 - Dec 2022",
    description:
      "A web designing agency website made using HTML, CSS, advanced flexbox and media query",
    tags: [
      "Bootstrap", "HTML", "CSS"],
    category: "Bootstrap",
    image : "https://i.ibb.co/vjzRX5v/Screenshot-2024-03-16-191951.png",
    github: "https://github.com/DebdiptoBiswas/Web-Design-Agency-Project",
    webapp : "https://debdiptobiswas.github.io/Web-Design-Agency-Project/",
  },
];